import config from "@config";
import { Constants } from "@constants/index";

const getCookie = (cname) => {
  const name = `${cname}=`;
  const cookieList = document.cookie.split(";");
  for (let i = 0; i < cookieList.length; i += 1) {
    const cookieItem = cookieList[i]?.trim();
    if (cookieItem.indexOf(name) === 0) {
      return cookieItem.split("=")[1];
    }
  }
  return "";
};

const deleteCookie = (name) => {
  document.cookie = `${name
  }=; expires=Thu, 01 Jan 1970 00:00:01 GMT; domain=.gartner.com; path=/; `;
};

export const getAuthorizationToken = (name) => {
  const domain = window.location.host;
  if (domain.indexOf(config.APP_LOCAL_PATH) !== -1) {
    return getCookie(name);
  }
  return localStorage.getItem(name);
};


export const deleteAuthorizationToken = (name) => {
  const domain = window.location.host;
  if (domain.indexOf(config.APP_LOCAL_PATH) !== -1) {
    return deleteCookie(name);
  }
  return localStorage.removeItem(name);
};

export const deleteAllCookies = () => {
  // Get all cookies as a string and split into individual cookies
  const cookies = document.cookie.split(";");

  for (let cookie of cookies) {
    // Get the cookie name
    const eqPos = cookie.indexOf("=");
    const name = eqPos > -1 ? cookie.substr(0, eqPos).trim() : cookie.trim();

    // Set the cookie's expiry date to the past for root path
    document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/`;

    // Optionally, try to delete for current path as well (for some browsers)
    document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=${window.location.pathname}`;
  }
}

/**
+ * Returns the current environment based on the provided hostname.
+ *
+ * @param {string} hostname - The hostname to determine the environment for.
+ * @return {string} The corresponding environment URL.
+ */
export const getRedirectUrl = () => {
  const { hostname } = location;
  switch (hostname) {
    case Constants.HEADER.HOSTNAME_DEV:
      return Constants.HEADER.GCOM_REDIRECTION_DEV;
    case Constants.HEADER.HOSTNAME_QA:
      return Constants.HEADER.GCOM_REDIRECTION_QA;
    default:
      return Constants.GARTNER_URL;
  }
};
